import { useRecoilValue } from 'recoil';
import { integrationAtom } from '../atom';
import { SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import { useMemo } from 'react';
import { getAtsCandidateUrl } from '../utils/getAtsCandidateUrl';

const buttonsContainer: SxProps = {
  px: 0
};

type Props = {
  atsCandidateId: string | null | undefined;
  atsApplicationId: string | null | undefined;
};

export const AtsCandidateLink: React.FC<Props> = ({
  atsCandidateId,
  atsApplicationId
}) => {
  const integrationCredentials = useRecoilValue(integrationAtom);

  const url = useMemo(() => {
    return getAtsCandidateUrl({
      integrationCredentials,
      atsCandidateId,
      atsApplicationId
    });
  }, [atsCandidateId, integrationCredentials, atsApplicationId]);

  if (!url) {
    return null;
  }

  return (
    <Button
      sx={buttonsContainer}
      onClick={() => {
        window.open(url, '_blank');
      }}
    >
      ATS
    </Button>
  );
};
